import _initializerDefineProperty from "@babel/runtime/helpers/initializerDefineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _applyDecoratedDescriptor from "@babel/runtime/helpers/applyDecoratedDescriptor";
import _initializerWarningHelper from "@babel/runtime/helpers/initializerWarningHelper";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Model } from 'libx';
import { action, observable } from 'mobx';
export var CallParticipantStatus = {
  Unknown: 'Unknown',
  Invited: 'Invited',
  Declined: 'Declined',
  Missed: 'Missed',
  Connecting: 'Connecting',
  Connected: 'Connected',
  Disconnected: 'Disconnected'
};
export var CallParticipant = (_dec = action.bound, _dec2 = action.bound, _dec3 = action.bound, _dec4 = action.bound, _dec5 = action.bound, _class = /*#__PURE__*/function (_Model) {
  function CallParticipant(call, primeMember) {
    var _this;
    _classCallCheck(this, CallParticipant);
    _this = _callSuper(this, CallParticipant);
    _initializerDefineProperty(_this, "userPublicId", _descriptor, _this);
    _initializerDefineProperty(_this, "member", _descriptor2, _this);
    _initializerDefineProperty(_this, "status", _descriptor3, _this);
    _this._call = call;
    _this._primeMember = primeMember;
    return _this;
  }

  /**
   * Marks the participant as connecting.
   */
  _inherits(CallParticipant, _Model);
  return _createClass(CallParticipant, [{
    key: "markConnecting",
    value: function markConnecting() {
      this.status = CallParticipantStatus.Connecting;
    }

    /**
     * Marks the participant as connected.
     */
  }, {
    key: "markConnected",
    value: function markConnected() {
      this.status = CallParticipantStatus.Connected;
    }

    /**
     * Marks the participant as disconnected.
     */
  }, {
    key: "markDisconnected",
    value: function markDisconnected() {
      this.status = CallParticipantStatus.Disconnected;
    }

    /**
     * Marks the participant as declined
     */
  }, {
    key: "markDeclined",
    value: function markDeclined() {
      this.status = CallParticipantStatus.Declined;
    }

    /**
     * Marks the participant as declined
     */
  }, {
    key: "markMissed",
    value: function markMissed() {
      this.status = CallParticipantStatus.Missed;
    }
  }, {
    key: "parse",
    value: function parse(json) {
      return {
        userPublicId: json.user_public_id,
        status: this.status === CallParticipantStatus.Connecting || this.status === CallParticipantStatus.Connected ? undefined : CallParticipant.maybeMapParticipantStatus(json.status),
        member: this._primeMember({
          user_id: json.user_id,
          user_public_id: json.user_public_id,
          workspace_id: this._call.conversation.workspaceId
        })
      };
    }

    /**
     * Since we have a `Connecting` status locally but not on the server,
     * we need to map.
     *
     * @param {string | undefined} status
     */
  }], [{
    key: "maybeMapParticipantStatus",
    value: function maybeMapParticipantStatus(status) {
      switch (status) {
        case 'INVITED':
          return CallParticipantStatus.Invited;
        case 'CONNECTED':
          return CallParticipantStatus.Connected;
        case 'DISCONNECTED':
          return CallParticipantStatus.Disconnected;
        case 'DECLINED':
          return CallParticipantStatus.Declined;
        case 'MISSED':
          return CallParticipantStatus.Missed;
        case undefined:
          return undefined;
        default:
          return CallParticipantStatus.Unknown;
      }
    }
  }]);
}(Model), _descriptor = _applyDecoratedDescriptor(_class.prototype, "userPublicId", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return '';
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "member", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return null;
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "status", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return CallParticipantStatus.Unknown;
  }
}), _applyDecoratedDescriptor(_class.prototype, "markConnecting", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "markConnecting"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markConnected", [_dec2], Object.getOwnPropertyDescriptor(_class.prototype, "markConnected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markDisconnected", [_dec3], Object.getOwnPropertyDescriptor(_class.prototype, "markDisconnected"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markDeclined", [_dec4], Object.getOwnPropertyDescriptor(_class.prototype, "markDeclined"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "markMissed", [_dec5], Object.getOwnPropertyDescriptor(_class.prototype, "markMissed"), _class.prototype), _class);
//# sourceMappingURL=CallParticipant.js.map
